'use strict';

wbApp.factory('smsHistorySvc', ['$resource', '$translate', '$q', 'notificationSvc', 'repositorySvc',
    function ($resource, $translate, $q, notificationSvc, repositorySvc) {

        var SmsHistory = $resource('/Api/SmsHistory', {}, {
            'query': { method: 'GET', isArray: true },
            'getAll': { method: 'GET', isArray: true, url: '/Api/SmsHistory/GetAll' },
        });

        var smsHistory = null;

        function getAll(refresh) {
            if (!smsHistory || refresh) {
                smsHistory = repositorySvc.customGet('getAll', SmsHistory);
            }
            return smsHistory;
        }

        return {
            getAll: getAll
        }
    }]);